import { Accordion } from "react-bootstrap";
import "./QuestionSingle.css";

const QuestionSingle = ({ question, answer, id }) => {
  return (
    <Accordion.Item eventKey={id}>
      <Accordion.Header className="questions-accordion-header">
        {question}
      </Accordion.Header>
      <Accordion.Body>{answer}</Accordion.Body>
    </Accordion.Item>
  );
};

export default QuestionSingle;
